'use strict';

class InvoiceView {
  constructor($http, $routeParams, $location, invoiceService, Notification) {
    this.$http = $http;
    this.$location = $location;
    this.invoiceService = invoiceService;
    // this.salesLedgerService = salesLedgerService;
    this.Notification = Notification;

    this.number = $routeParams.number;
  }

  $onInit() {
    this.invoice = {};
    // this.salesledger = {
    //   entries: []
    // };

    this.load();
  }

  load() {
    // console.log('  ** invoice load invoice get');

    this.invoiceService.get(this.number)
      .then((resp) => {
        this.invoice = resp.data;
        return resp.data;
      })
      .catch((err) => {
        if (err.status === 404) {
          this.$location.path('/beslutning-kreves');
        }
      });
  }

  cancelAgiroRequest() {
      swal({
        title: 'Kanseller AvtaleGiro?',
        text: 'Dette kan ikke omgjøres.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#0c4d91',
        confirmButtonText: 'Ok',
        cancelButtonText: 'Avbryt',
        closeOnConfirm: true
      }, (answer) => {
        if (answer) {
          this.$http.post(this.invoice._links.cancelAgiroRequest.uri)
            .then(() => {
            this.Notification.success('AvtaleGiro oppdrag ble kansellert');
          this.load();
        });
        }
      });
    }

  cancelCollection() {
    this.$http.post(this.invoice._links.cancelCollection.uri)
      .then(() => {
        this.Notification.success('Regningen er flyttet tilbake til beslutning kreves');
        this.load();
      });
  }
}

InvoiceView.$inject = ['$http', '$routeParams', '$location', 'invoiceService', 'Notification'];

const invoiceView = {
  controller: InvoiceView,
  templateUrl: 'invoice/view.html'
};

angular
  .module('SendRegning')
  .component('invoiceView', invoiceView)
  .config(($routeProvider) => {
    $routeProvider
      .when('/regning/:number', {
        title: 'Vis regning',
        template: '<invoice-view />',
        secure: true
      });
  });
